import React, { useMemo, useState } from 'react';
import {
    Box, Button, Container, CssBaseline, Tab, Tabs, ThemeProvider, Typography,
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useSelector } from 'react-redux';

import theme from '../../theme';
import Topbar from '../Topbar';
import { withLanguage } from '../common/Texts';
import { aiAdminTokens as t } from './tokens';
import useAIAdminData from './useAIAdminData';
import SpecsTab from './SpecsTab';
import ModelsTab from './ModelsTab';
import AccountTab from './AccountTab';

export default function AIAdmin() {
    const language = useSelector((s) => s.user.language);
    const tr = useMemo(() => withLanguage(language), [language]);

    const { specs, models, account, reload } = useAIAdminData();
    const [tab, setTab] = useState(0);

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline/>
            <Topbar/>

            <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', pb: 8 }}>
                <Container maxWidth="lg" sx={{ pt: 4 }}>
                    <Box sx={{
                        display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
                        gap: 2, flexWrap: 'wrap',
                    }}>
                        <Box>
                            <Typography sx={{ fontFamily: t.font.sans, fontSize: 22, fontWeight: 700 }}>
                                {tr('ai_admin_title')}
                            </Typography>
                            <Typography sx={{ fontFamily: t.font.sans, fontSize: 13.5, mt: 0.5 }}>
                                {tr('ai_admin_subtitle')}
                            </Typography>
                        </Box>
                        <Button variant="outlined" size="small" startIcon={<RefreshIcon/>} onClick={reload}>
                            {tr('ai_admin_refresh')}
                        </Button>
                    </Box>

                    <Tabs
                        value={tab}
                        onChange={(_, value) => setTab(value)}
                        sx={{ mt: 3, mb: 2, borderBottom: `1px solid ${t.color.divider}` }}
                    >
                        <Tab label={tr('ai_admin_specs')} sx={{ fontFamily: t.font.sans }}/>
                        <Tab label={tr('ai_admin_models')} sx={{ fontFamily: t.font.sans }}/>
                        <Tab label={tr('ai_admin_account')} sx={{ fontFamily: t.font.sans }}/>
                    </Tabs>

                    {tab === 0 && (
                        <SpecsTab tr={tr} specs={specs}/>
                    )}
                    {tab === 1 && <ModelsTab tr={tr} models={models}/>}
                    {tab === 2 && <AccountTab tr={tr} account={account}/>}
                </Container>
            </Box>
        </ThemeProvider>
    );
}
